
import type { Locale } from "antd/lib/locale-provider";
import fa_IR from "antd/lib/locale/fa_IR";


export const jalaliLocale: Locale = {
    ...fa_IR,
    DatePicker: {
        ...fa_IR.DatePicker,
        lang: {
            ...(fa_IR.DatePicker?.lang || {}),
            monthFormat: 'MMMM'
        }
    }
} as Locale; 